export function Header() {
  return (
    <header className="border-b border-border backdrop-blur-xl bg-background/80 sticky top-0 z-50">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-xl font-bold text-primary-foreground">3D</span>
          </div>
          <h1 className="text-2xl font-bold text-foreground">
            Card Builder
          </h1>
        </div>
      </div>
    </header>
  )
}
